import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import Image from '../../components/Image';
import { openUrl } from '../../utils/miscellaneous';

function EventSponsors({ event: { sponsors = [] } }) {
  return (
    <Box sx={{ width: '100%', overflowY: 'auto' }}>
      <Box sx={{ display: 'flex', width: `${sponsors.length * 128}px` }}>
        {sponsors.map((sponsor) => (
          <Box
            key={sponsor.id}
            sx={{
              width: '120px',
              marginRight: '8px',
            }}
            onClick={() => {openUrl(sponsor.website)}}
          >
            <Image
              ratio="21/9"
              sx={{
                borderRadius: '16px',
              }}
              src={sponsor.logo}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
}

EventSponsors.propTypes = {
  event: PropTypes.object.isRequired,
};

export default EventSponsors;
